const handleLoadMore = () => {
  const $blogContainer = $('.blog');
  const $itemsContainer = $blogContainer.find('.block-list');
  const $loadMoreButtonContainer = $blogContainer.find('.page__actions');

  $blogContainer.on('click', '.js-load-more', function(event) {
    const url = $(this).attr('href');

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      beforeSend: function() {
        $blogContainer.addClass('loader');
      },
      success: function(data) {
        const $items = $(data).find('.blog .block-list').children();
        const $newLoadButton = $(data).find('.blog .page__actions');

        $items.appendTo($itemsContainer);

        if ($newLoadButton.length > 0) {
          $loadMoreButtonContainer.html($newLoadButton.html());
        } else {
          $loadMoreButtonContainer.remove();
        }

        setTimeout(function() {
          $blogContainer.removeClass('loader');
        }, 400);
      }
    });

    event.preventDefault();
  });
}

$(document).ready(function() {
  handleLoadMore();
});
